// Legia II w 2 lidze (StatsBomb 2043/351) — lustro backend/app/reserves.py.
// Raport pomeczowy Legii II = ten sam silnik co pierwszego zespołu, tło kafli = 2 liga,
// bez tagowania, celów sztabu, ocen i targetów IKZ (ustawionych pod Ekstraklasę).
export const RESERVES_TEAM_ID = 44901
export const RESERVES_BASE = '/raporty/legia-ii'
export const RESERVES_LABEL = 'Legia II'
